<template>
  <div :class="['op--modal-container', {hide: !show}]" @click="close">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="static-locations" @click.stop>
          <div class="sl-tab">
            <span :class="{'active':showTab === 'airports'}" @click="switchTab('airports')">
              <div>
                <i class="fas fa-plane"></i>{{ $t('searchForm.airports') }}
              </div>
            </span>
            <span :class="{'active':showTab === 'hilton'}" @click="switchTab('hilton')" v-if="isMasimo">
              <i class="fas fa-location-arrow"></i>Hilton
            </span>
            <span :class="{'active':showTab === 'themeParks'}" @click="switchTab('themeParks')" v-if="!isMasimo">
              <i class="fab fa-fort-awesome"></i>{{ $t('searchForm.themeParks') }}
            </span>
            <span :class="{'active':showTab === 'ports'}" @click="switchTab('ports')" v-if="!isMasimo">
              <div>
                <i class="fas fa-map-marker-alt"></i>{{ $t('searchForm.ports') }}
              </div>
            </span>
            <span :class="{'active':showTab === 'hotels'}" @click="switchTab('hotels')" v-if="!isMasimo">
              <div>
                <i class="fas fa-building"></i>{{ $t('searchForm.hotel') }}
              </div>
            </span>
            <span :class="{'active':showTab === 'universities'}" @click="switchTab('universities')" v-if="!isMasimo">
              <div>
                <i class="fas fa-graduation-cap"></i>{{ $t('searchForm.universities') }}
              </div>
            </span>
          </div>

          <div :class="{'sl-body':true, 'show-airport':showAirports}">
            <div class="sl-content airport" v-show="showTab === 'airports'">
              <div class="margin-b-s">
                <input type="text" class="field-text" v-model="airportInput"
                  @keyup="filterAirports" ref="airportInput" />
              </div>
              <ul>
                <li v-for="(item, index) in airports" @click="setLocation('airports', index)">
                  <i class="fas fa-plane"></i>{{ item.shortName }}
                </li>
              </ul>

              <div class="modal-cancel margin-t-s margin-b-m">
                <span class="op-btn btn-block" @click="close">{{ $t('common.cancel') }}</span>
              </div>
            </div>

            <div class="sl-content park" v-show="showTab === 'hilton' && isMasimo">
              <div class="margin-b-s">
                <input type="text" class="field-text" v-model="hiltonInput"
                  @keyup="filterHilton" ref="hiltonInput" />
              </div>

              <ul>
                <li v-for="(item, index) in hilton" :key="index" @click="setLocation('hilton', index)">{{ item.shortName }}</li>
              </ul>
              <div class="modal-cancel margin-t-s margin-b-m">
                <span class="op-btn btn-block" @click="close">{{ $t('common.cancel') }}</span>
              </div>
            </div>

            <div class="sl-content park" v-show="showTab === 'themeParks' && !isMasimo">
              <div class="margin-b-s">
                <input type="text" class="field-text" v-model="parkInput" @keyup="filterParks" ref="parkInput" />
              </div>

              <ul>
                <li v-for="(item, index) in parks" @click="setLocation('parks', index)">
                  <i class="fab fa-fort-awesome"></i>{{ item.shortName }}
                </li>
              </ul>
              <div class="modal-cancel margin-t-s margin-b-m">
                <span class="op-btn btn-block" @click="close">{{ $t('common.cancel') }}</span>
              </div>
            </div>

            <div class="sl-content ports" v-show="showTab === 'ports' && !isMasimo">
              <div class="margin-b-s">
                <input type="text" class="field-text" v-model="portsInput"
                  @keyup="filterPorts" ref="portsInput" />
              </div>

              <ul>
                <li v-for="(item, index) in ports" @click="setLocation('ports', index)">
                  <i class="fas fa-map-marker-alt"></i>{{ item.shortName }}
                </li>
              </ul>
              <div class="modal-cancel margin-t-s margin-b-m">
                <span class="op-btn btn-block" @click="close">{{ $t('common.cancel') }}</span>
              </div>
            </div>

            <div class="sl-content hotels" v-show="showTab === 'hotels' && !isMasimo">
              <div class="margin-b-s">
                <input type="text" class="field-text" v-model="hotelsInput"
                  @keyup="filterHotels" ref="hotelsInput" />
              </div>

              <ul>
                <li v-for="(item, index) in hotels" @click="setLocation('hotels', index)">
                  <i class="fas fa-building"></i>{{ item.shortName }}
                </li>
              </ul>
              <div class="modal-cancel margin-t-s margin-b-m">
                <span class="op-btn btn-block" @click="close">{{ $t('common.cancel') }}</span>
              </div>
            </div>

            <div class="sl-content universities" v-show="showTab === 'universities' && !isMasimo">
              <div class="margin-b-s">
                <input type="text" class="field-text" v-model="universitiesInput"
                  @keyup="filterUniversities" ref="universitiesInput" />
              </div>

              <ul>
                <li v-for="(item, index) in universities" @click="setLocation('universities', index)">
                  <i class="fas fa-graduation-cap"></i>{{ item.shortName }}
                </li>
              </ul>
              <div class="modal-cancel margin-t-s margin-b-m">
                <span class="op-btn btn-block" @click="close">{{ $t('common.cancel') }}</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
export default {
  name: 'static-location-modal',
  props: ['field', 'id'],
  data () {
    return {
      show: false,
      showTab: '',
      showAirports: true,
      airportInput: '',
      parkInput: '',
      portsInput: '',
      hotelsInput: '',
      universitiesInput: '',
      hiltonInput: '',
      airports: [],
      hotels: [],
      ports: [],
      universities: [],
      hilton: [
        {
          address1: '3050 Bristol St',
          address2: '',
          city: 'Costa Mesa',
          zip: '92626',
          state: 'CA',
          country: 'United States',
          lat: 33.68312,
          lng: -117.88438,
          title: '3050 Bristol St, Costa Mesa, CA 92626',
          shortName: 'Hilton - Costa Mesa',
          longName: '3050 Bristol St, Costa Mesa, CA 92626'
        }
      ],
      parks: this.$store.state.reservation.staticLocations.parks,
      isMasimo: false,
      sortOnLoad: false
    }
  },
  computed: {
    _airports () { return this.$store.state.staticLocations.airports },
    _hotels () { return this.$store.state.staticLocations.hotels },
    _ports () { return this.$store.state.staticLocations.ports },
    _universities () { return this.$store.state.staticLocations.universities },
    brandId () { return this.$store.state.brandId }
  },
  methods: {
    showModal (x) {
      this.showTab = x
      this.show = true
      this.sortAll()
    },
    close () { this.show = false },
    setLocation (type, index) {
      let selected = this[type][index]

      if (this.field === 'charter') {
        this.$store.commit('reservation/setCharterData', {pickup: selected})
        this.$store.commit('reservation/setPickup', {
          leg: 'leg1',
          value: selected
        })
      } else if (this.field === 'extraStop') {
        this.$store.commit('reservation/setExtraStopLocationData', {
          leg: 'leg1',
          id: this.id,
          value: selected
        })
      } else {
        let locationType = this.field.charAt(0).toUpperCase() + this.field.substr(1)
        this.$store.commit('reservation/set' + locationType, {
          leg: 'leg1',
          value: selected
        })
      }

      this.show = false
      this.$emit('select', {
        field: this.field,
        keyInput: selected.longName
      })

      let trackData = {}
      trackData[`${this.field}Type`] = type
      this.$store.commit('tracking/setOpoliCnsData', trackData)

      let isAirport = type === 'airports'
      let tmpStoreCommit = this.field === 'pickup' ? 'reservation/setIsAirportPickup' : 'reservation/setIsAirportDropoff'
      this.$store.commit(tmpStoreCommit, {
        leg: 'leg1',
        value: isAirport
      })

      if (CONFIG.Env == 'production' && window.gtag) { // eslint-disable-line
        let field = this.field.charAt(0).toUpperCase() + this.field.slice(1)
        gtag('event', `${field}_Location`, { // eslint-disable-line
          category: type.charAt(0).toUpperCase() + type.slice(1),
          value: selected.longName
        })
      }
    },
    filterAirports () {
      let self = this
      let result = []
      let list = self._airports

      for (let index in list) {
        if (list[index].shortName.toLowerCase().indexOf(self.airportInput.toLowerCase()) < 0) { continue }
        result.push(list[index])
      }
      self.airports = result
    },
    filterParks () {
      let self = this
      let regex = new RegExp('^' + self.parkInput.toLowerCase(), 'i')
      let result = {}
      let list = self.$store.state.reservation.staticLocations.parks

      for (let index in list) {
        if (!regex.test(list[index].shortName.toLowerCase())) { continue }
        result[index] = list[index]
      }
      self.parks = result
    },
    filterPorts () {
      let self = this
      let result = []
      let list = self._ports

      for (let index in list) {
        if (list[index].shortName.toLowerCase().indexOf(self.portsInput.toLowerCase()) < 0) { continue }
        result.push(list[index])
      }
      self.ports = result
    },
    filterHotels () {
      let self = this
      let result = []
      let list = self._hotels

      for (let index in list) {
        if (list[index].shortName.toLowerCase().indexOf(self.hotelsInput.toLowerCase()) < 0) { continue }
        result.push(list[index])
      }
      self.hotels = result
    },
    filterUniversities () {
      let self = this
      let result = []
      let list = self._universities

      for (let index in list) {
        if (list[index].shortName.toLowerCase().indexOf(self.universitiesInput.toLowerCase()) < 0) { continue }
        result.push(list[index])
      }
      self.universities = result
    },
    filterHilton () {
      let self = this
      let result = []
      let list = self.hilton

      for (let index in list) {
        if (list[index].shortName.toLowerCase().indexOf(self.universitiesInput.toLowerCase()) < 0) { continue }
        result.push(list[index])
      }
      self.hilton = result
    },
    switchTab (target) {
      let self = this
      self.showTab = target
      if (target === 'airports') {
        self.$nextTick(function () { self.$refs.airportInput.focus() })
      }
      if (target === 'themeParks') {
        self.$nextTick(function () { self.$refs.parkInput.focus() })
      }
      if (target === 'ports') {
        self.$nextTick(function () { self.$refs.portsInput.focus() })
      }
      if (target === 'hotels') {
        self.$nextTick(function () { self.$refs.hotelsInput.focus() })
      }
      if (target === 'universities') {
        self.$nextTick(function () { self.$refs.universitiesInput.focus() })
      }
    },
    sortAll () {
      this.sortList('airports')
      // this.sortList('hotels')
      // this.sortList('ports')
      // this.sortList('universities')
    },
    sortList (type) {
      if (!this[`_${type}`].length) return

      let rsvp = this.$store.state.reservation.leg1
      let pickup = {lat: 33.94414, lng: -118.403268} // LAX
      if (this.field === 'dropoff' && rsvp.pickup.lat && rsvp.pickup.lng) pickup = rsvp.pickup

      let temp = [...this[type]]
      let lax = ''
      if (type === 'airports' && this.field === 'dropoff') {
        let laxIndex = temp.findIndex(x => x.shortName.includes('(LAX)'))
        lax = temp[laxIndex]
        if (laxIndex > -1) {
          temp.splice(laxIndex, 1)
        }
      }
      temp.sort((a, b) => this.distanceCheck(pickup, a) - this.distanceCheck(pickup, b))
      let firstSeven = temp.slice(0, 7)
      let alphaSort = temp.slice(7, temp.length)
      let fieldSort = type === 'airports' ? 'city' : 'shortName'
      alphaSort = alphaSort.sort((a, b) => a[fieldSort] > b[fieldSort] ? 1 : (a[fieldSort] < b[fieldSort] ? -1 : 0))
      this[type] = firstSeven.concat(alphaSort)
      if (lax) {
        this[type].unshift(lax)
      }
    },
    distanceCheck (coord1, coord2) {
      let toRad = value => value * Math.PI / 180
      let R = 6371
      let latD = toRad(coord2.lat - coord1.lat)
      let longD = toRad(coord2.lng - coord1.lng)
      let a = Math.sin(latD / 2) * Math.sin(latD / 2) +
        Math.cos(toRad(coord1.lat)) * Math.cos(toRad(coord2.lat)) *
        Math.sin(longD / 2) * Math.sin(longD / 2)
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      let distance = R * c
      return distance / 1.609344
    }
  },
  watch: {
    show: function (value) {
      let self = this
      document.body.classList.remove('widget-no-scroll')
      if (value) {
        document.body.classList.add('widget-no-scroll')
        if (self.showTab === 'airports') {
          self.$nextTick(function () { self.$refs.airportInput.focus() })
        }
        if (self.showTab === 'themeParks') {
          self.$nextTick(function () { self.$refs.parkInput.focus() })
        }
        if (self.showTab === 'ports') {
          self.$nextTick(function () { self.$refs.portsInput.focus() })
        }
        if (self.showTab === 'hotels') {
          self.$nextTick(function () { self.$refs.hotelsInput.focus() })
        }
        if (self.showTab === 'universities') {
          self.$nextTick(function () { self.$refs.universitiesInput.focus() })
        }
      }
    },
    _airports: function (value) {
      this.airports = value
      if (!this.sortOnLoad) {
        this.sortOnLoad = true
        this.sortAll()
      }
    },
    _hotels: function (value) { this.hotels = value },
    _ports: function (value) { this.ports = value },
    _universities: function (value) { this.universities = value },
    brandId: function (value) {
      let brandId = value
      for (var key in CONFIG.Brands) {
        if (CONFIG.Brands[key].id === brandId && CONFIG.Brands[key].code === 'ms') {
          this.isMasimo = true
        }
      }
    }
  },
  mounted () {
    let brandId = this.$store.state.brandId
    for (var key in CONFIG.Brands) {
      if (CONFIG.Brands[key].id === brandId && CONFIG.Brands[key].code === 'ms') {
        this.isMasimo = true
      }
    }

    if (this._airports.length) {
      this.airports = this._airports
    }
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container{
  overflow: auto;
  -webkit-overflow-scrolling:touch;
}

.static-locations{
  background-color: #fff;
  max-width: 550px;
  margin: 0 auto;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  font-family: 'Questrial', sans-serif;
  height: 480px;
}

.sl-tab{
  display: flex;
  text-align: center;

  span{
    width: 50%;
    display: inline-block;
    padding: 12px 5px;
    cursor: pointer;
    background: #f6f6f6;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
    position: relative;

    &.active{
      background: #fff;
      border-bottom: none;
    }
    &:not(.active){
      box-shadow: 0 -1px 1px rgba(0,0,0, .05) inset;
      color: #aaa;
    }
    div{
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      text-align: center;
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
    }
    /*&:first-child:not(.active){ border-right: 1px solid #ddd }*/
    /*&:last-child{ border-left: none; }*/
    i{ display:block; }
    .fa-fort-awesome{ color: #f18538; }
    .fa-plane{ color: #84a2bb; }
    .fa-map-marker-alt{ color: #ff4d3b; }
    .fa-building{ color: #91a2c7; }
    .fa-graduation-cap{ color: #2c3e50; }
  }
}

.sl-body{
  position: relative;
  height: 100%;
  overflow: auto;

  .sl-content{
    padding: 20px;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    transition: all .2s ease;

    ul{
      padding: 0;
      margin: 0;
      border-top: 1px solid #ddd;
      list-style: none;
      height: 100%;
      max-height: 260px;
      overflow: auto;

      li{
        display: block;
        border-bottom: 1px solid #ddd;
        padding: 7px 5px;
        cursor: pointer;
        transition: all .3s ease;
        font-size: 14px;

        &:hover{ background:#f9f9f9; }
        i{
          margin-right: 5px;
        }
      }
    }
  }
}

.modal-cancel{
  text-align:center;
  span{
    cursor: pointer;
    color:#aaa;

    &:hover{
      text-decoration:underline;
      color:#777;
    }
  }
}
</style>



// WEBPACK FOOTER //
// StaticLocationModal.vue?e81bb912